<ion-header class="check-pin-modal__header">
  <shared-close (tap)="dismiss()"></shared-close>
</ion-header>
<ion-content class="check-pin-modal__content">
  <h1 class="check-pin-modal__content__title">
    {{ translate._("TYPE_PIN") }}
  </h1>
  <shared-pin [pinLength]="4" (event)="checkPin($event)"></shared-pin>
</ion-content>
